import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import EventDetailsMain from "./EventDetailsMain";
import { useLocation, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getEventById, getAllEvents } from "../../services/eventsServices";

const EventDetails = () => {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("eventId");
  const location = useLocation();

  const [event, setEvent] = useState(null);
  const [relatedEvents, setRelatedEvents] = useState([]);

  // Fetch single event by ID
  const {
    data: eventData,
    isLoading: eventLoading,
    isError: eventError,
    error: eventErrorData,
  } = useQuery({
    queryKey: ["event", eventId],
    queryFn: () => getEventById(eventId),
    enabled: !!eventId,
  });

  // Extract category ID from the current event
  const categoryId = event?.category?._id || event?.category;

  // Fetch related events with limit of 4
  const {
    data: relatedEventsData,
    isLoading: relatedEventsLoading,
    isError: relatedEventsError,
    error: relatedEventsErrorData,
  } = useQuery({
    queryKey: ["relatedEvents", categoryId, { limit: 4 }],
    queryFn: () =>
      getAllEvents({
        limit: 4,
        status: "active",
        approvalStatus: "approved",
        category: categoryId,
      }),
    enabled: !!categoryId,
  });

  useEffect(() => {
    document.title = "Event Details | Society of Aquaculture Professionals";
  }, []);

  useEffect(() => {
    if (eventData) {
      setEvent(eventData.data);
    }
  }, [eventData]);

  useEffect(() => {
    if (relatedEventsData) {
      const eventsArray = relatedEventsData.data?.data || [];

      const filtered = eventsArray
        .filter((e) => e._id !== eventId)
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .slice(0, 4);

      setRelatedEvents(filtered);
    }
  }, [relatedEventsData, eventId]);

  const queryParams = new URLSearchParams(location.search);
  const urlTitle = queryParams.get("title") || "Event Details";
  const formattedTitle = decodeURIComponent(urlTitle.replace(/\+/g, " "));

  return (
    <>
      <Header />

      <EventDetailsMain
        event={event}
        relatedEvents={relatedEvents}
        isLoading={eventLoading || relatedEventsLoading}
        isError={eventError || relatedEventsError}
        error={eventErrorData || relatedEventsErrorData}
        formattedTitle={formattedTitle}
        categoryName={event?.category?.name}
      />

      <Footer />
    </>
  );
};

export default EventDetails;
